<template>
  <div>
    <div class="row">
        <div class="col-md-12 px-0" >
                <div @click="goBack" class="btn w-100 skywhitebtn backbtn mplus2p-r  mb-3 peditboxes">
                  <img style="float: left; margin-top: 2px;" src="../../assets/imgs/backarrow.png" /> 
                    <span style="margin-left:-50px">
                    {{$t('chat_back')}}
                    </span>
                </div>
            </div>
            <div v-if="window_width <= (768-17)" class="col-md-12" @click="clicked_moreoption">
                  <div class="mmenu_item" id="more_option">
                    <span class="mmenu_item_txt mplus2p-m spacing1-2">View Option</span>
                    <span class="mmenu_item_arrow mplus2p-m spacing1-2">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </div>
              </div>
            <div  v-for="(option, index) in skillEngineer" :key="index" class="input-group engineerList">
                <!-- <input type="text" class="form-control searchbox" :placeholder="$t('find_job')" aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
                <multiselect v-model="selectedSkill"  :label="lan=='en' ? 'en_name' : 'jp_name'" track-by="code" :placeholder="$t('c_search_keyword')" open-direction="bottom" :options="option.skilldropdown" :multiple="true" :clear-on-select="true" :close-on-select="false" :options-limit="300"   :max-height="600" :show-no-results="false" :hide-selected="true">
                  <template slot="tag" slot-scope="props">
                    <div class="option__desc skillTag">
                      <span class="option__title">{{ lan=='en' ? props.option.en_name : props.option.jp_name }}</span>
                      <span class="custom__remove" @click="props.remove(props.option)">
                        <i style="right: 6px; position: absolute; cursor:pointer" class="fa fa-times" aria-hidden="true"></i>
                      </span>
                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">{{ lan=='en' ? props.option.en_name : props.option.jp_name }}</span>
                    </div>
                  </template>
                  <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </multiselect>
                <div class="input-group-append">
                    <button @click="searchFilter()" class="btn btn-outline-secondary" type="button">
                    <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
          
          <!-- Expertise -->
         <div class="col-md-12  checkgrouppanel" data-target="#expertise"  data-toggle="collapse"  aria-expanded="false">
          <span  data-target="#expertise" data-toggle="collapse" aria-expanded="false" class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-id-badge fa-lg"></i> {{ $t('expertise') }}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="expertise">
            <li v-for="(expertise, index) in expertises" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label  class="custom-control material-checkbox">
                  <input :for="expertise.id" type="checkbox" v-on:change="applyFilter()" v-model="expertise.isChecked" class="material-control-input" :id="expertise.id" >
                  <span class="material-control-indicator"></span>
                  <span class="material-control-description">{{lan == 'en' ? expertise.en_expertise : expertise.jp_expertise}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>
        <!-- Required Position-->
        <div class="col-md-12 checkgrouppanel" data-target="#requiredPostion" data-toggle="collapse" aria-expanded="false">
          <span  class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-blind fa-lg"></i> {{ $t('required_position') }}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="requiredPostion">
            <li v-for="(position, index) in requiredPostion" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label class="custom-control material-checkbox">
                  <input :for="position.id" type="checkbox" v-on:change="applyFilter()" v-model="position.isChecked" class="material-control-input" :id="position.id">
                  <span class="material-control-indicator"></span>
                  <span  class="material-control-description">{{lan == 'en' ?  position.en_required_position : position.jp_required_position}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>

        <!-- Required typr of contract -->
        <div class="checkgrouppanel" data-target="#business_type" data-toggle="collapse" aria-expanded="false">
          <span class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-handshake-o fa-lg"></i> {{$t('requried_type_of_contract')}}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="business_type">
            <li v-for="(contract, index) in requiredContracts" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label class="custom-control material-checkbox">
                  <input :for="contract.id" type="checkbox" v-on:change="applyFilter()" v-model="contract.isChecked" class="material-control-input" :id="contract.id">
                  <span class="material-control-indicator"></span>
                  <span v-if="lan == 'en'" class="material-control-description">{{$t( contract.en_required_type)}}</span>
                  <span v-if="lan == 'jp'" class="material-control-description">{{$t( contract.jp_required_type)}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>

        <!-- Years experiences -->
        <div class="checkgrouppanel" data-target="#experiences" data-toggle="collapse" aria-expanded="false">
          <span class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-calendar fa-lg"></i> {{$t('engineers_years')}}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="experiences">
            <li v-for="(position, index) in experiences" :key="index" v-on:click.stop>
              <div class="custom-control custom-radio">
                <input type="radio" name="customRadio2"  @change="applyFilter()" v-model="experience" :id="'experience'+position.id" :value="position.id" class="custom-control-input">
                <label v-if="lan == 'en'" class="custom-control-label" :for="'experience'+position.id">{{position.en_experience}}</label>
                <label v-else class="custom-control-label" :for="'experience'+position.id">{{position.jp_experience}}</label>
              </div>
            </li>
          </ul>
        </div>

        <!-- work_areas -->
        <div class="checkgrouppanel" data-target="#workAreas" data-toggle="collapse" aria-expanded="false">
          <span class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-clock-o fa-lg"></i> {{$t('required_work_Area_to_be')}}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="workAreas">
            <li v-for="(position, index) in workAreas" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label class="custom-control material-checkbox">
                  <input :for="position.id" type="checkbox" v-on:change="applyFilter()" v-model="position.isChecked" class="material-control-input" :id="position.id">
                  <span class="material-control-indicator"></span>
                  <span v-if="lan == 'en'" class="material-control-description">{{$t( position.en_work_area)}}</span>
                  <span v-if="lan == 'jp'" class="material-control-description">{{$t( position.jp_work_area)}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>

        <!-- languages -->
        <div class="checkgrouppanel" data-target="#languages" data-toggle="collapse" aria-expanded="false">
          <span class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-th-large fa-lg"></i> {{$t('languages')}}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="languages">
            <li v-for="(position, index) in languages" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label class="custom-control material-checkbox">
                  <input :for="position.id" type="checkbox" v-on:change="applyFilter()" v-model="position.isChecked" class="material-control-input" :id="position.id">
                  <span class="material-control-indicator"></span>
                  <span v-if="lan == 'en'" class="material-control-description">{{$t( position.en_language)}}</span>
                  <span v-if="lan == 'jp'" class="material-control-description">{{$t( position.jp_language)}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>

        <!-- experienced corporate -->
        <div class="checkgrouppanel" :class="{'d-none' : role == 'company_user'}" data-target="#experiencedCorporate" data-toggle="collapse" aria-expanded="false">
          <span class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-calendar fa-lg"></i> {{$t('experienced_corporate')}}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="experiencedCorporate">
            <li v-for="(position, index) in experiencedCorporate" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label class="custom-control material-checkbox">
                  <input :for="position.id" type="checkbox" v-on:change="applyFilter()" v-model="position.isChecked" class="material-control-input" :id="position.id">
                  <span class="material-control-indicator"></span>
                  <span v-if="lan == 'en'" class="material-control-description">{{$t( position.en_corporate)}}</span>
                  <span v-if="lan == 'jp'" class="material-control-description">{{$t( position.jp_corporate)}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>

         <!-- Job Sekking -->
        <div class="checkgrouppanel" data-target="#jobSeeking" data-toggle="collapse" aria-expanded="false">
          <span class="checkgrouplabel mplus2p-m spacing1-2">
              <i class="fa fa-search-plus fa-lg"></i> {{$t('ep_job_seeking')}}
            <span class="dropdown-toggle text-right"></span>
          </span>
          <ul class="collapse cline list-unstyled mt-3" id="jobSeeking">
            <li v-for="(job, index) in jobSeekings" :key="index" v-on:click.stop>
              <div class="custom-controls-stacked d-block my-3">
                <label class="custom-control material-checkbox">
                  <input :for="job.id" type="checkbox" v-on:change="applyFilter()" v-model="job.isChecked" class="material-control-input" :id="job.id">
                  <span class="material-control-indicator"></span>
                  <span v-if="lan == 'en'" class="material-control-description">{{$t( job.en_situation)}}</span>
                  <span v-if="lan == 'jp'" class="material-control-description">{{$t( job.jp_situation)}}</span>
                </label>
              </div>
            </li>
          </ul>
        </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../../main.js";
export default {
  data() {
    return {
      window_width: "",
      selectedItem: "",
      role: "",
      expertises: [],
      skillEngineer: [],
      selectedSkill : '',
      isLoading: false,

      selectedLanguage: "",

      requiredPostion: [],

      requiredContracts: [],
      
      experience: '',
      experiences: [],

      workAreas: [],

      languages: [],

      experiencedCorporate: [],

      jobSeekings:[]
    };
  },
  created() {
    this.role = localStorage.getItem("role");
    this.window_width = $(window).width() + 17; //default
    this.showorhide();

     if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    this.getExpertises();
    this.getRequiredPosition();
    this.getRequiredContract();
    this.getRequiredExprience();
    this.getWorkAreas();
    this.getLanguages();
    this.getExperiencedCorporate();
    this.searchSkill();
    this.getJobSeeking();
  },
  computed: {
    onResize(event) {
      this.window_width = $(window).width() + 17;
      this.showorhide();
    }
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  methods: {
     goBack() {
      var data = JSON.parse(localStorage.getItem("user"));
      var userId = data.user_token;
      var companyId = data.company.company_token;
      this.$router.push("/company/company-user-profile/" + companyId + "/" + userId);
    },

    showorhide() {
      if (this.window_width > 768) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      }
      if (this.window_width <= 768) {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },

    clicked_moreoption() {
      if ($(".options").hasClass("hider")) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      } else {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    clearAll () {
      this.selectedCountries = []
    },
    addNewSkill(newTag, index) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
        clicked: true
      };
      this.searchSkillEngineer[index].skilldropdown.push(tag);
      this.searchSkillEngineer[index].chooseskill.push(tag);
    },
    getJobSeeking() {
      axios
        .get("/job-seeking-situations")
        .then(res => {
          this.jobSeekings = res.data.situations;
        })
        .catch(error => console.log(error));
    },
     searchSkill() {
      axios
        .get("/items-for-search?token=" + localStorage.getItem("token"))
        .then(res => {
          var skills = [];
          for (var j = 0; j < res.data.items.length; j++) {
            skills.push({
              id: res.data.items[j].id,
              code: res.data.items[j].check_content,
              en_name: res.data.items[j].check_content,
              jp_name: res.data.items[j].jp_check_content
            });
          }
          
          this.skillEngineer.push({
                skilldropdown: skills,
          });
        })
        .catch(error => console.log(error));
    },
   
     getExpertises() {
      axios
        .get("/expertises?token=" + localStorage.getItem("token"))
        .then(res => {
          this.expertises = res.data.item;
        })
        .catch(error => console.log(error));
    },
    getRequiredPosition() {
      axios
        .get("/user-positions")
        .then(res => {
          this.requiredPostion = res.data.positions;
        })
        .catch(error => console.log(error));
    },

    getRequiredContract() {
      axios
        .get("/user-position-types")
        .then(res => {
          this.requiredContracts = res.data.types;
        })
        .catch(error => console.log(error));
    },

    getRequiredExprience() {
      axios
        .get("/experiences")
        .then(res => {
          this.experiences = res.data.experiences;
          var addAll = 
            {
                id: 'all',
                en_experience: "all",
                jp_experience: "全て",
                created_at: "2018-10-05 06:11:03",
                updated_at: "2018-10-05 06:11:03"
              };
          this.experiences.splice(0, 1, addAll)
        })
        .catch(error => console.log(error));
    },

    getWorkAreas() {
      axios
        .get("/work-areas")
        .then(res => {
          this.workAreas = res.data.work_areas;
        })
        .catch(error => console.log(error));
    },

    getLanguages() {
      axios
        .get("/engineer-languages")
        .then(res => {
          this.languages = res.data.languages;
        })
        .catch(error => console.log(error));
    },

    getExperiencedCorporate() {
      axios
        .get("/experienced-corporates")
        .then(res => {
          this.experiencedCorporate = res.data.corporates;
        })
        .catch(error => console.log(error));
    },
    searchFilter(){
      let data = {};
      if (this.selectedSkill.length > 0)
      {
        let selectedSkills = this.selectedSkill
        .filter(obj => {
          return  obj.id;
        })
        .map(item => {
          return item.id;
        });
        data = selectedSkills;
      }
      this.$parent.$emit("searchFilter", data);
    },
    applyFilter() {
      let expertise_id = this.expertises
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });
      
      let required_position_id = this.requiredPostion
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });

      let required_contract_id = this.requiredContracts
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });

      let required_work_area_to_be_id = this.workAreas
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });

      let language_id = this.languages
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });

      let experienced_corporate_id = this.experiencedCorporate
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });

      let job_seeking_situation_id = this.jobSeekings
        .filter(obj => {
          return obj.isChecked ? obj.id : false;
        })
        .map(item => {
          return item.id;
        });

      let data = {};
      if (expertise_id.length > 0)
        data["expertise_id"] = expertise_id;
      if (required_position_id.length > 0)
        data["required_position_id"] = required_position_id;
      if (required_contract_id.length > 0)
        data["required_contract_id"] = required_contract_id;
      if (this.experience != '')
        data["engineer_years_id"] = this.experience;
      if (required_work_area_to_be_id.length > 0)
        data["required_work_area_to_be_id"] = required_work_area_to_be_id;
      if (language_id.length > 0) data["language_id"] = language_id;
      if (experienced_corporate_id.length > 0)
        data["experienced_corporate_id"] = experienced_corporate_id;
      if (job_seeking_situation_id.length > 0)
        data["job_seeking_situation_id"] = job_seeking_situation_id;

      this.$parent.$emit("applyFilter", data);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.skillTag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #3d7dd8 !important;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  min-height: 22px !important;
}
.multiselect__tags-wrap .multiselect__tag {
  background: #3d7dd8 !important;
}
.custom-control.material-checkbox {
  --color: #3d7dd8;
}
.custom-radio .custom-control-input:checked~.custom-control-label::before {
    background-color: #3d7dd8;
}
.custom-control-input:checked~.custom-control-label::before {
    color: #fff;
    background-color: #3d7dd8;
}
.custom-control.material-checkbox .material-control-input {
  display: none;
}

.custom-control.material-checkbox
  .material-control-input:checked
  ~ .material-control-indicator {
  border-color: var(--color);
  -webkit-transform: rotateZ(45deg) translate(1px, -5px);
  transform: rotateZ(45deg) translate(1px, -5px);
  width: 10px;
  border-top: 0px solid #fff;
  border-left: 0px solid #fff;
}

.custom-control.material-checkbox .material-control-indicator {
  display: inline-block;
  position: absolute;
  top: 4px;
  left: 0;
  width: 16px;
  height: 16px;
  border: 2px solid #aaa;
  transition: 0.3s;
}

a {
  color: #3c5064;
}

.companyad {
  width: 95%;
  margin-top: 5px;
}

.leftad {
  padding: 50px 20px;
}

.rightad {
  text-align: center;
  padding: 5px 0px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.filterSpinner {
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.searchbox {
  height: 40px;
  border-radius: 4px;
  background-color: #f0f2f4;
  border: 1px solid #58606800;
}

.input-group-append {
  border-top-right-radius: 6.4px;
  border-bottom-right-radius: 6.4px;
  background-color: #3d7dd8;
  max-height: 42px;
}

.input-group-append button {
  color: white;
  border: 1px solid #58606800;
}

.input-group-append:hover button {
  color: #3d7dd8 !important;
}

.btn-outline-secondary:hover {
  background-color: white;
  color: #3d7dd8 !important;
}

.extxt {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(60, 80, 100, 0.8);
}

.checklabel {
  font-size: 0.8125rem;
  font-weight: 500;
}

.styled-checkbox + label:before {
  margin-right: 12px;
  margin-top: -2px;
}

.checkgrouplabel {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #3c5064;
}

.checkgrouppanel {
  width: 100%;
  /* height: 44px; */
  border-radius: 4px;
  padding: 13px 15px;
  background-color: white;
  border: solid 1px #e6e8ea;
  margin-top: 8px;
  cursor: pointer;
}

.checkgrouppanelbtn {
  width: 100%;
  /* height: 44px; */
  border-radius: 4px;
  background-color: white;
  border: solid 1px #e6e8ea;

  cursor: pointer;
}

.unstyled {
  margin-top: 13px;
}

.unstyled li {
  margin-top: 1px;
}

/* li:after {
    content: "\f107";
    font-family: FontAwesome;
    font-size: 22px;
    position: absolute;
    right: 30px;
    color: #6474847d;
    margin-top: -2px;
  } */
span[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  margin-top: 10px;
  float: right;
  transform: translateY(-50%);
}
.custom-control {
  position: relative;
  display: block;
  min-height: 0.5rem;
  padding-left: 1.5rem;
  margin-top: 10px;
  margin-left: 10px;
  padding-bottom: 10px;
}
.companyview-topoptions {
  padding: 10px 15px;
  margin-top: 10px;
}

.companyview-topoptions .col-md-3 {
  padding: 0;
}

.companyview-topoptions .col-md-9 {
  padding: 0;
}

.selectdiv:after {
  content: "\f107";
  color: #6474847d;
  top: 3px;
}

.selectdiv select {
  height: 44px;
}

.rtoptions {
  margin-top: 14px;
  float: left;
  margin-left: 40px;
}

.ceboxes {
  margin: 16px;
  margin-top: 26px;
  margin-bottom: 0px;
  text-align: center;
}

#pointer {
  width: 59.7px;
  height: 24px;
  background: #3d7dd8;
  box-shadow: 0 1px 2px 0 rgba(60, 80, 100, 0.12);

  position: absolute;
  z-index: 1;
  left: 0;
  top: 7px;
}

#pointer:after {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 12px solid #3d7dd8;
  border-bottom: 12px solid transparent;
}

#pointer:before {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 12px solid #3d7dd8;
  border-top: 12px solid transparent;
}

.newtag {
  font-size: 0.6875rem;
  font-weight: bold;
  color: white;
}

.c_images {
  width: 85%;
  border-radius: 18px;
}

.ctitle {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 10px;
}

.ccontents {
  font-size: 0.625rem;
}

.cline {
  border: solid 2px #e6e8ea;
  margin-top: 15px;
  margin-bottom: 15px;
}

.cstitle {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);

  float: right;
  margin-top: 10px;
  margin-bottom: 20px;
}

.cplus {
  font-size: 1.5em;
  line-height: 1;
}

.skillsets {
  text-align: left;
  padding: 9px 10px;
}

.backbtn {
  border-radius: 8px;
    margin-top: 10px;
    padding: 10px 15px;
    font-weight: bold;
}

@media screen and (max-width: 992px) {
  .rightad {
    padding: 50px 0px;
  }
}

@media screen and (max-width: 768px) {
  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .rightad {
    padding: 0px 10px;
  }

  .leftad {
    padding: 20px 10px;
  }

  .rtoptions {
    margin-top: 14px;
    float: none;
    margin-left: 0px;
  }

  .skillsets {
    padding: 0;
    margin-top: 20px;
  }

  .ceboxes .col-md-3 {
    margin-bottom: 30px;
  }

  .c_images {
    width: 144px;
  }
}
</style>